











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class YLine extends Vue {
  @Prop({
    default: {}
  })
  public config!: any;

  @Prop({
    default: {
      value: 0,
      label: false,
      bold: false
    }
  })
  public line!: any;

  public fillStyleForYLine(line: any) {
    return {
      bottom: (((line.value - this.config.yOffset) / this.config.yLength) * 100) + '%'
    }

  }

}
